import React, { useEffect } from 'react';

import Header from '../../layout/Header.jsx';
import ListAchievements from '../../lists/ListAchievements.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';

const PageAchievements = () => {
  const [res, req] = useHttpStatus();
  useEffect(() => {
    req({
      url: '/api/quiz/levels',
      params: { limit: 50, sort: { score: -1 } },
    });
  }, []);

  return (
  <div>
    <Header>Achievements</Header>
    <ListAchievements
      level={res.payload || {}}
    />
  </div>
  );
};

export default PageAchievements;
